// -----------------------------------------------------------------------------
// Scripts for product comparison
// -----------------------------------------------------------------------------


$(function () {
	// Dynamic height of data item
	const setDataItemsHeight = function () {
		const loader = $('.loader');
		const prodLabels = $('.prod-list__item.active .prod-list__label');

		loader.addClass('loader--active');

		$.each(prodLabels, function (index, value) {
			const itemLabelId = $(this).attr('id');
			const dataItems = $(`[data-label="${itemLabelId}"]`);
			let dataItemHeight = 0;

			$.each(dataItems, function (index, value) {
				$(value).css('height', 'auto');
				const currentDataItemHeight = $(value).outerHeight(true);

				if (currentDataItemHeight >= dataItemHeight) {
					dataItemHeight = currentDataItemHeight;
				}

				$(value).outerHeight(dataItemHeight);
			});

			$(`#${itemLabelId}, [data-label="${itemLabelId}"]`).outerHeight(dataItemHeight);
		});

		setTimeout(function() {	
			loader.removeClass('loader--active');	
		}, 50);
	}

	let onResizeTimeout = null;
	$(window).on('resize', function() {
		if(onResizeTimeout) {
			clearTimeout(onResizeTimeout);
		}
		onResizeTimeout = setTimeout(setDataItemsHeight, 100);
	});


	// Sliders
	const sliders = $('.prod-list__item');

	$.each(sliders, function (index, value) {
		const singleSlider = $(this).find('.prod-list__slider').attr('id');

		$(`#${singleSlider}`).slick({
			autoplay: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			variableWidth: true,
			infinite: false,
			fade: false,
			centerMode: false,
			arrows: false,
			dots: false,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						variableWidth: false,
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						variableWidth: false,
					}
				},
			]
		});

		$(`#${singleSlider}`).on('reInit', function (slick) {
			setTimeout(setDataItemsHeight, 100);
		});

		$(document).on('click', '.prod-list__slider-remove-btn', function() {
			var parent = $(this).parents('.slick-slide[data-slick-index]');
			console.log(parent, 'parent');
			var slickIndex = parent.index();
			console.log(slickIndex, 'slickIndex');
			parent.parents('.slick-slider').slick('slickRemove', slickIndex);
		});


		// Custom navigation
		$('.prod-list__arrow--prev').click(function () {
			const slider = $(this).attr('data-slider');

			$(`#${slider}`).slick('slickPrev');
		});

		$('.prod-list__arrow--next').click(function () {
			const slider = $(this).attr('data-slider');

			$(`#${slider}`).slick('slickNext');
		});
	});


	// Tabs
	setTimeout(function () {
		const selectedTabContent = '#contentItem0';
    	const loader = $('.loader');

		let activeTabNav = $('.prod-categories__item');
		let activeTabContent = $('.prod-list__item');

    	loader.addClass('loader--active');

		if (activeTabNav && activeTabContent) {
			activeTabNav.removeClass('active');
			activeTabContent.removeClass('active');
		}

		$(selectedTabContent).addClass('active');

		$(selectedTabContent).find('.prod-list__slider').trigger('reInit');
    	$('.prod-list__slider').slick('setPosition'); 
    
		setTimeout(function() {
			loader.removeClass('loader--active');
		}, 800);
	});
});